import { put, call } from 'redux-saga/effects';
import { stateSearchAPI } from 'src/api/StateApi';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { STATE_ACTIONS } from '../actions/StateActions';

function* search() {
    try {
        const {
            data: {
                data,
            },
        } = yield call(stateSearchAPI, {
            pageLength: 0,
        });

        yield put({
            type: STATE_ACTIONS.STATE_SEARCH_SUCCESS,
            data,
        });
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: STATE_ACTIONS.STATE_SEARCH_ERROR,
        });
    }
}

export default [
    takeFirstSagaUtil(STATE_ACTIONS.STATE_SEARCH, search),
];
